import UniversalProductsPage from 'pages/UniversalProductsPage/UniversalProductsPage';

export default UniversalProductsPage;
